module.exports = __webpack_public_path__ + "img/contact-bubble.ce69f9c5.svg";